import { useOutletContext } from 'react-router-dom';
import React, {useState, useLayoutEffect, useRef} from 'react';

async function getAccountData(uuid) {
    const response = await fetch('/api/get-friend-account-data-uuid', {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include",
        body: JSON.stringify({
            friend_uuid: uuid,
        })
    });

    const data = await response.json();

    if (response.ok) {
        return data
    } else {
        return false;
    }
}

async function removeFriend(uuid) {
    const response = await fetch('/api/remove-account-friend', {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include",
        body: JSON.stringify({
            friend_uuid: uuid,
        })
    });

    const data = await response.json();

    if (response.ok) {
        return data
    } else {
        return false;
    }
}

function AccountActualFriends() {
    const {userCurrentFriends} = useOutletContext();
    const hasInitialized = useRef(false);
    const [userFriendsData, setUserFriendsData] = useState([])

    useLayoutEffect(() => {
        const getFriendsData = async () => {
            if (!hasInitialized.current && userCurrentFriends) {
                await Promise.all(
                    userCurrentFriends.map(async (uuid) => {
                        var data = await getAccountData(uuid)
                        data.nome = data.name + " " + data.surname
                        data.user_uuid = uuid;
                        setUserFriendsData([...userFriendsData, data])
                    })
                );
                hasInitialized.current = true;
            }
        };

        getFriendsData()
    }, [userCurrentFriends, userFriendsData])

    const handleRemove = (user_uuid, id) => async () => {
        var data = await removeFriend(user_uuid)
        console.log(data);
        setUserFriendsData(prev => prev.filter(item => item.friendCode !== id));
    };

    return (
        <div>
            <div className="flex items-center justify-between px-2 pb-4 pt-2">
                <h3 className="text-slate-900 dark:text-white text-lg font-bold leading-tight tracking-tight uppercase font-display">Current Friends ({userFriendsData.length})</h3>
            </div>
            <div className="grid gap-3">
                {userFriendsData.length === 0 ? (
                    <p className="text-slate-500 text-center py-8">Empty</p>
                ) : (
                    userFriendsData.map((userFriendsData) => (
                        <div 
                        key={userFriendsData.friendCode} 
                        className="flex flex-col md:flex-row items-start gap-[15px] justify-start md:gap-0 md:items-center md:justify-between p-4 bg-slate-50 dark:bg-surface-dark border border-slate-200 dark:border-border-dark rounded-xl hover:border-primary/50 transition-all group"
                        >
                        <div className="flex items-center gap-4">
                            <div className="relative">
                            {}
                            <div 
                                className="size-12 rounded-lg bg-slate-200 dark:bg-border-dark bg-cover bg-center border border-slate-300 dark:border-slate-700" 
                            ></div>
                            
                            {}
                            <span className="absolute -bottom-1 -right-1 flex h-4 w-4 items-center justify-center rounded-full bg-surface-dark border-2 border-surface-dark">
                                <span className={`h-2 w-2 rounded-full ${userFriendsData.status === 'online' ? 'bg-primary' : 'bg-slate-500'}`}></span>
                            </span>
                            </div>

                            <div className="flex flex-col">
                            <span className="text-slate-900 dark:text-white font-bold text-base font-display">
                                {userFriendsData.nome}
                            </span>
                            <div className="flex items-center gap-2">
                                <span className={`${userFriendsData.status === 'online' ? 'text-primary' : 'text-slate-500'} text-[10px] font-bold uppercase tracking-widest`}>
                                {userFriendsData.status}
                                </span>
                            </div>
                            </div>
                        </div>

                        <div className="flex items-center gap-2">
                            <button className="h-9 px-4 bg-primary text-white text-xs font-bold rounded-lg hover:bg-primary/90 transition-all uppercase flex items-center gap-2">
                            <span className="material-symbols-outlined text-sm">analytics</span> View Telemetry
                            </button>
                            
                            {}
                            <button 
                            onClick={handleRemove(userFriendsData.user_uuid, userFriendsData.friendCode)}
                            className="h-9 px-4 bg-slate-200 dark:bg-border-dark text-slate-600 dark:text-slate-300 text-xs font-bold rounded-lg hover:bg-red-500/20 hover:text-red-500 transition-all uppercase"
                            >
                            Remove
                            </button>
                        </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
}

export default AccountActualFriends;